import { render, staticRenderFns } from "./QuestionToSolve.vue?vue&type=template&id=1032d508&scoped=true&"
import script from "./QuestionToSolve.vue?vue&type=script&lang=js&"
export * from "./QuestionToSolve.vue?vue&type=script&lang=js&"
import style0 from "./QuestionToSolve.vue?vue&type=style&index=0&id=1032d508&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1032d508",
  null
  
)

export default component.exports